import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TPostGenerateContractorIDUploadLinkPrivateRequest,
  TPostGenerateContractorIDUploadLinkPrivateResponse,
} from "./postGenerateContractorIDUploadLinkPrivate.schema";

export const postGenerateContractorIDUploadLinkPrivate = (
  axios: IAxiosInstance
) => {
  return async (
    params: TPostGenerateContractorIDUploadLinkPrivateRequest
  ): Promise<string> => {
    const response =
      await axios.noRetry.post<TPostGenerateContractorIDUploadLinkPrivateResponse>(
        `/api/contractors/id_upload_link`,
        params
      );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Failed to generate contractor document upload link");
  };
};
